import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 5a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2l0 -14","key":"svg-0"}],["path",{"d":"M8 4l2 0","key":"svg-1"}],["path",{"d":"M9 17l0 .01","key":"svg-2"}],["path",{"d":"M21 6l-2 3l2 3l-2 3l2 3","key":"svg-3"}]]

const IconDeviceMobileVibration = createReactComponent('outline', 'device-mobile-vibration', 'DeviceMobileVibration', __iconNode);

export default IconDeviceMobileVibration;